/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DataTable.RowActions.Dropdown.vue?vue&type=template&id=41f68e79"
import script from "./DataTable.RowActions.Dropdown.vue?vue&type=script&lang=js"
export * from "./DataTable.RowActions.Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports